import { Vue, Component, Ref } from 'vue-property-decorator'
import VtThumbnail from '@/components/common/VtThumbnail.vue'
import { BModal } from 'bootstrap-vue'
import {
    AttachmentsListModalDetailState,
    initialAttachmentsListModalDetailState
} from '@/modules/laboratoryModule/laboratoryTracking/modals/attachments-list-modal-detail/attachments-list-modal-detail.model'
import { ENTITIES_LABORATORY } from '@/modules/laboratoryModule/config/sidebarConfig'
import portionAttachmentService from '@/api/resources/attachment/portionAttachmentService'
import subportionAttachmentService from '@/api/resources/attachment/subportionAttachmentService'
import sampleAttachmentService from '@/api/resources/attachment/sampleAttachmentService'

@Component({
    components: {
        VtThumbnail
    }
})
export default class AttachmentsListModalDetail extends Vue {
    @Ref() readonly attachmentsListModalDetail!: BModal

    state: AttachmentsListModalDetailState
    constructor() {
        super()
        this.state = initialAttachmentsListModalDetailState()
    }

    private async _getPortionAttachments(laboratoryId: number, caseId: number, sampleId: number, portionId: number): Promise<any[]> {
        const response = await this.$_toCallSecure(portionAttachmentService.getAttachments(laboratoryId, caseId, sampleId, portionId, undefined))
        return response ?? [] // TODO: migrate service to typescript
    }

    private async _getSubportionAttachments(laboratoryId: number, caseId: number, sampleId: number, portionId: number, subportionId: number): Promise<any[]> {
        const response = await this.$_toCallSecure(subportionAttachmentService.getAttachments(laboratoryId, caseId, sampleId, portionId, subportionId, undefined))
        return response ?? [] // TODO: migrate service to typescript
    }

    private async _getSampleAttachments(laboratoryId: number, caseId: number, sampleId: number): Promise<any[]> {
        const response = await this.$_toCallSecure(sampleAttachmentService.getAttachments(laboratoryId, caseId, sampleId, undefined))
        return response ?? [] // TODO: migrate service to typescript
    }

    private async _setStateByType(information: any, type: string): Promise<void> {
        switch (type) {
        case ENTITIES_LABORATORY.PORTION:
            this.state.label = information.porLabel
            this.state.caseId = information.sample?.caseStudy?.casId
            this.state.sampleId = information.sample?.samId
            this.state.portionId = information.porId

            if (this.state.caseId && this.state.sampleId && this.state.portionId) {
                this.state.attachments =
                        await this._getPortionAttachments(
                            this.state.laboratoryId,
                            this.state.caseId,
                            this.state.sampleId,
                            this.state.portionId)
            }
            break
        case ENTITIES_LABORATORY.SUBPORTION:
            this.state.label = information.supLabel
            this.state.caseId = information.portion?.sample?.caseStudy?.casId
            this.state.sampleId = information.portion?.sample?.samId
            this.state.portionId = information.portion?.porId
            this.state.subportionId = information.supId

            if (this.state.caseId && this.state.sampleId && this.state.portionId && this.state.subportionId) {
                this.state.attachments =
                        await this._getSubportionAttachments(
                            this.state.laboratoryId,
                            this.state.caseId,
                            this.state.sampleId,
                            this.state.portionId,
                            this.state.subportionId)
            }
            break
        case ENTITIES_LABORATORY.SAMPLE:
            this.state.label = information.samLabel
            this.state.caseId = information.caseStudy?.casId
            this.state.sampleId = information.samId

            if (this.state.caseId && this.state.sampleId) {
                this.state.attachments =
                        await this._getSampleAttachments(
                            this.state.laboratoryId,
                            this.state.caseId,
                            this.state.sampleId)
            }
            break
        default:
            this.state.label = null
            this.state.caseId = null
            this.state.sampleId = null
            this.state.portionId = null
            this.state.subportionId = null
            this.state.attachments = []
            break
        }
    }

    async show(entityInformation: any, type: string): Promise<void> {
        await this._setStateByType(entityInformation, type)
        this.attachmentsListModalDetail.show()
    }

    hide(): void {
        this.attachmentsListModalDetail.hide()
    }
}
